<template>
  <div class="scenario_bar">

    <p class="control firstGroup">
      <input
        type="file"
        id="jsonFile"
        name="jsonFile"
        style="display: none;"
      />
      <button
        class="button importScenario"
        v-on:click="importScenario()"
      >
        <span class="icon">
          <i class="fas fa-file-import"></i>
        </span>
        <span>{{ $t('common.actions.import') }}</span>
      </button>
      <button
        class="button"
        v-on:click="exportScenario()"
      >
        <span class="icon">
          <i class="fas fa-file-export"></i>
        </span>
        <span>{{ $t('common.actions.export') }}</span>
      </button>
    </p>

    <p class="control secondGroup">
      <button
        class="button is-primary saveScenarioButton"
        v-on:click="save(true)"
      >
        <span class="icon">
          <i class="fa fa-floppy-o"></i>
        </span>
        <span>{{ $t('common.actions.save') }}</span>
      </button>
      <button
        class="button is-light"
        v-on:click="showTestCall()"
        v-if="!!this._props.scenario.id"
      >
        <span class="icon">
          <i class="fas fa-phone-volume"></i>
        </span>
        <span>{{ $t('testCall.testCall') }}</span>
      </button>
    </p>
    <test-call
      v-show="!!testCall"
      v-if="!!this._props.scenario.id"
      :close-test-call="closeTestCall"
      :scenario.sync="scenario"
      :campaign-id="campaignId"
    />
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import BaseComponent from './../BaseComponent'
import TestCall from './TestCall'

const api = '/api/scenarios'

export default {
  components: {TestCall},
  extends: BaseComponent,
  // name: 'Control',
  props: ['name', 'campaignId', 'scenario'],
  computed: {
    ...mapGetters([
      'loadedScenario',
      'loggedId',
      'loggedUser',
      'authenticationToken'
    ])
  },
  data() {
    return {
      testCall: false
    }
  },
  methods: {
    prepareSecurityHeader() {
      // console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },
    changeRoute: function (e) {
      this.$router.push({path: '/scenarios' + e.target.value})
    },
    // load() {
    //   let that = this
    //   this.$http({
    //     url: api + '/' + this._props.name,
    //     headers: this.prepareSecurityHeader()
    //   }).then((response) => {
    //     // console.log('opening scenario ' + JSON.stringify(response.data))
    //     that.$emit('set', response.data)
    //   }).catch((error) => {
    //     console.log(error)
    //     this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario)
    //     this.$emit('setDefault')
    //   })
    // },
    save(showMessage) {
      if (this.isValid()) {
        if (!this._props.scenario.id) {
          this.saveNew(showMessage)
        } else {
          this.update(showMessage)
        }
      }
    },
    isValid() {
      if (!this.checkDuplicateTitleBlock()) {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с одинаковыми названиями блоков')
        return false
      }
      return true
    },
    checkDuplicateTitleBlock() {
      this.$emit('initScenario', this._props.scenario)
      let states = this._props.scenario.parameters.states
      console.log(states)
      let statesSet = new Set()
      for (const state of states) {
        console.log(state)
        if (state.type == 'inOutState') {
          continue
        }
        if (!statesSet.has(state.data.title)) {
          statesSet.add(state.data.title)
        } else {
          return false
        }
      }
      return true

      // for (let i = 0; i < states.length - 1; i++) {
      //   for (let j = i + 1; j < states.length; j++) {
      //     console.log(states[i])
      //     if (states[i].data.title === states[j].data.title &&
      //       states[i].type !== 'inOutState' &&
      //       states[j].type !== 'inOutState') {
      //       return false
      //     }
      //   }
      // }
      // return true
    },
    saveNew(showMessage) {
      this.$emit('initScenario', this._props.scenario)
      // console.log('saving new scenario: ' + JSON.stringify(this._props.scenario))
      let that = this
      this.$http.post(api, this._props.scenario, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          if (showMessage) {
            this.openNotificationWithType('info', that.$i18n.messages[that.$i18n.locale].notifications.scenario.scenarioSaved)
          }
          this.$emit('set', response.data)
          // that.createCampaign(response.data.id)
        }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorSaveScenario)
      })
    },
    update(showMessage) {
      this.$emit('initScenario', this._props.scenario)
      // console.log('updating scenario: ' + JSON.stringify(this._props.scenario))
      let that = this
      this.$http.put(api, this._props.scenario, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          if (showMessage) {
            this.openNotificationWithType('info', that.$i18n.messages[that.$i18n.locale].notifications.scenario.scenarioSaved)
          }
          this.$emit('set', response.data)
        }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorSaveScenario)
      })
    },

    readJsonFile(jsonFile) {
      let reader = new FileReader()
      reader.addEventListener('load', (loadEvent) => {
        try {
          let json = JSON.parse(loadEvent.target.result)
          this.$emit('set', {
            template: json.template,
            parameters: json.parameters,
            inUse: json.inUse,
            isReady: json.isReady,
            checkDuration: json.checkDuration
          })
          // console.log(json);
        } catch (error) {
          console.error(error)
        }
      })
      reader.readAsText(jsonFile)
    },

    importScenario() {
      document.getElementById('jsonFile').click()
    },

    exportScenario() {
      // function encode(s) {
      //   let out = []
      //   for (let i = 0; i < s.length; i++) {
      //     out[i] = s.charCodeAt(i)
      //   }
      //   return new Uint8Array(out)
      // }

      this.$emit('initScenario', this._props.scenario)

      let data = {
        template: this._props.scenario.template,
        parameters: this._props.scenario.parameters,
        inUse: this._props.scenario.inUse,
        isReady: this._props.scenario.isReady,
        checkDuration: this._props.scenario.checkDuration
      }

      // data = encode(JSON.stringify(data, null, 4))
      data = JSON.stringify(data, null, 4)

      let blob = new Blob([data], {
        type: 'application/octet-stream'
      })

      let link = document.createElement('a')
      link.setAttribute('href', URL.createObjectURL(blob))
      link.setAttribute('download', this._props.scenario.name + '.json')

      let event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null)
      link.dispatchEvent(event)
    },

    cancel() {
      if (!this.$props.campaignId) {
        this.$router.push('/scenarios/')
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignId)
      }
    },

    showTestCall() {
      this.testCall = true
    },
    closeTestCall() {
      this.testCall = false
    }
  },
  created: function () {
    // this.loadState()
    if (!this._props.name) {
      console.log('creating new scenario')
      this.$emit('setDefault')
    } else {
      // console.log('loading scenario: ' + !this.$props.name)
      // this.load()
    }
  },
  mounted: function () {
    let that = this
    document.getElementById('jsonFile').addEventListener(
      'change',
      changeEvent => {
        changeEvent.stopPropagation()
        changeEvent.preventDefault()
        that.readJsonFile(changeEvent.target.files[0])
      },
      false
    )
  }
}
</script>

<style scoped>
.scenario_bar {
  /*margin-top: 40px;*/
  /*float: right;*/
}

.saveScenarioButton {
  margin-left: 8px;
}

#Konstruktor.scrolled .scenarioBarShell {
  background: transparent;
}

#Konstruktor.scrolled .scenarioBarShell .scenario_bar {
  margin-top: 0;
  background: transparent;
}

#Konstruktor.scrolled .scenarioBarShell .scenario_bar p {
  display: inline-block;
  background: transparent;
}

#Konstruktor.scrolled .scenarioBarShell .scenario_bar p.firstGroup {
  margin-right: 400px;
}
</style>



// WEBPACK FOOTER //
// ToolButtons.vue?0d3c8671